import type { DateTimeSerializable } from '@vs-shop/schemas/DateTimeSerializable';
import {
  ArticleCard,
  ArticleCardBody,
  ArticleCardExcerpt,
  ArticleCardImage,
  ArticleCardMediaFrame,
  ArticleCardMediaLink,
  ArticleCardTitle,
  ArticleCardTitleLink,
  ArticleCardVariant,
} from '@vs-shop/commerce-ui/articleCard';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../../../../utils/intl';

import Link from '@vs-shop/image-link/Link';
import { ArticleInfoHeader } from '../ArticleInfoHeader';
import { TextLink } from '@vs-shop/ui/textLink';

import {
  type ArticleAuthorIndex,
  type ArticleAuthorIndexFavourite,
} from '../../../../../effect/schema/openapi/backend';

type Props = {
  imgSrc: string;
  imgAlt: string;
  heading: string;
  perex: string;
  author: ArticleAuthorIndex | ArticleAuthorIndexFavourite | null;
  publishedAt: DateTimeSerializable | null;
  routerUrl: string;
};

export default function ArticleDetailPreview({
  imgSrc,
  imgAlt,
  heading,
  perex,
  author,
  publishedAt,
  routerUrl,
}: Props) {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  return (
    <ArticleCard variant={ArticleCardVariant.STACKED}>
      <ArticleCardMediaLink variant={ArticleCardVariant.STACKED} href={routerUrl}>
        <ArticleCardMediaFrame>
          <ArticleCardImage src={imgSrc} alt={imgAlt} width={375} height={281} />
        </ArticleCardMediaFrame>
      </ArticleCardMediaLink>

      <ArticleCardBody variant={ArticleCardVariant.STACKED}>
        <ArticleCardTitleLink href={routerUrl}>
          <ArticleCardTitle variant={ArticleCardVariant.STACKED}>{heading}</ArticleCardTitle>
        </ArticleCardTitleLink>

        <ArticleInfoHeader publishedAt={publishedAt} author={author} />

        <ArticleCardExcerpt variant={ArticleCardVariant.STACKED}>{perex}</ArticleCardExcerpt>
      </ArticleCardBody>

      <TextLink render={<Link href={routerUrl} />}>
        {intl.formatMessage({
          id: 'component.server.page.article.detail.ArticleDetailPreview.wholeArticle',
          defaultMessage: 'Zobrazit celý článek',
        })}
      </TextLink>
    </ArticleCard>
  );
}
